import { ClientCartDetail } from "common/types/carts";

import Alert from "client/common/components/content/Alert";

import styles from "../../styles/shared/CartMessages.module.less";

type CartMessagesProps = {
  className?: string;
  cart: ClientCartDetail;
};

const CartMessages = ({ className = "", cart }: CartMessagesProps) => {
  const { warning_messages: messages } = cart;

  if (!messages?.length) {
    return null;
  }

  return (
    <div className={`${styles.container} ${className}`}>
      {messages.map((message) => (
        <Alert key={message} variant="danger">
          {message}
        </Alert>
      ))}
    </div>
  );
};

export default CartMessages;
